module.exports.remote_config = {
    // BACKEND_URL : 'http://localhost:2000',
    BACKEND_URL: 'https://shopnow-backend-14pc.onrender.com'
}